var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c("b-col", [
            _c("h2", [_vm._v(_vm._s(_vm.$t("message.addressDetails.title")))])
          ])
        ],
        1
      ),
      _vm._v(" "),
      !_vm.isEditable
        ? _c(
            "div",
            [
              _c(
                "b-row",
                { staticClass: "mt-4" },
                [
                  _c(
                    "b-col",
                    [
                      _vm.currentAddress
                        ? _c(
                            "Infobox",
                            {
                              attrs: {
                                title: _vm.title,
                                subtitle: _vm.subtitle,
                                variant: "noHover"
                              }
                            },
                            [
                              _c("span", {
                                staticClass: "infobox-icon ti-home"
                              })
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-4" },
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-btn",
                        { attrs: { variant: "link" }, on: { click: _vm.back } },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("message.addressDetails.btn.back"))
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "text-right" },
                    [
                      _c(
                        "b-btn",
                        {
                          attrs: { variant: "primary" },
                          on: { click: _vm.editAddress }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("message.addressDetails.btn.edit"))
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-btn",
                        {
                          directives: [
                            {
                              name: "b-modal",
                              rawName: "v-b-modal.delete-address-model",
                              modifiers: { "delete-address-model": true }
                            }
                          ],
                          attrs: { variant: "danger" }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("message.addressDetails.btn.delete"))
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.isPolicyHolder
                ? _c(
                    "div",
                    { staticClass: "mt-5" },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            [
                              _c("contracts-card", {
                                attrs: {
                                  collapseId: "addressContracts",
                                  title: _vm.$t(
                                    "message.addressDetails.contractsCard.title"
                                  ),
                                  items: _vm.contractsByAddress
                                },
                                on: { showDetails: _vm.onShowDetails }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.contractsByAddress.length !== 0
                        ? _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-card",
                                    {
                                      staticClass: "rounded-0 mt-4",
                                      attrs: {
                                        title: _vm.$t(
                                          "message.addressDetails.moveTitle"
                                        )
                                      }
                                    },
                                    [
                                      _c(
                                        "b-row",
                                        [
                                          _vm.isSingleAddress
                                            ? _c("b-col", [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "message.addressDetails.moveMessageSingleAddr"
                                                      )
                                                    ) +
                                                    "\n              "
                                                )
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.isSingleAddress
                                            ? _c("b-col", [
                                                _vm._v(
                                                  "\n                " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "message.addressDetails.moveMessage"
                                                      )
                                                    ) +
                                                    "\n              "
                                                )
                                              ])
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        [
                                          _c(
                                            "b-col",
                                            _vm._l(
                                              Math.ceil(
                                                _vm.filteredAddresses.length / 3
                                              ),
                                              function(i) {
                                                return _c(
                                                  "b-row",
                                                  {
                                                    key: i,
                                                    staticClass: "mt-3"
                                                  },
                                                  _vm._l(
                                                    _vm.filteredAddresses.slice(
                                                      (i - 1) * 3,
                                                      i * 3
                                                    ),
                                                    function(address) {
                                                      return _c(
                                                        "b-col",
                                                        { key: address.id },
                                                        [
                                                          _c(
                                                            "b-btn",
                                                            {
                                                              staticClass:
                                                                "p-0 my-2 mr-4 rounded-0 btn-address w-100",
                                                              attrs: {
                                                                variant:
                                                                  "transparent"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  _vm.onSelectAddressbox(
                                                                    address
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "Infobox",
                                                                {
                                                                  class: _vm.getAddressBoxClass(
                                                                    address
                                                                  ),
                                                                  attrs: {
                                                                    title: _vm.getTitle(
                                                                      address
                                                                    ),
                                                                    subtitle:
                                                                      address.postalCode +
                                                                      " " +
                                                                      address.city
                                                                  }
                                                                },
                                                                [
                                                                  _c("span", {
                                                                    staticClass:
                                                                      "infobox-icon ti-home"
                                                                  })
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  )
                                                )
                                              }
                                            )
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      !_vm.isSingleAddress
                                        ? _c(
                                            "b-row",
                                            [
                                              _c(
                                                "b-col",
                                                { staticClass: "text-right" },
                                                [
                                                  _c(
                                                    "b-btn",
                                                    {
                                                      attrs: {
                                                        variant: "primary",
                                                        disabled:
                                                          _vm.contractsByAddress
                                                            .length === 0 ||
                                                          !_vm.newAddress
                                                      },
                                                      on: {
                                                        click:
                                                          _vm.updateContractsWithAddress
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                  " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "message.addressDetails.moveBtn"
                                                            )
                                                          ) +
                                                          "\n                "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _c(
            "div",
            [
              _c(
                "b-row",
                { staticClass: "mt-4" },
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "10" } },
                    [
                      _c("address-form", {
                        ref: "addressForm",
                        attrs: {
                          address: _vm.currentAddress,
                          onSubmitFn: _vm.saveAddress
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "text-right px-4", attrs: { cols: "10" } },
                    [
                      _c(
                        "b-btn",
                        {
                          attrs: { variant: "link" },
                          on: { click: _vm.cancel }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t("message.addressDetails.btn.cancel")
                              ) +
                              "\n        "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-btn",
                        {
                          attrs: { variant: "primary" },
                          on: { click: _vm.saveAddress }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t("message.addressDetails.btn.save")
                              ) +
                              "\n        "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "delete-address-model",
            "cancel-variant": "primary",
            "ok-variant": "danger",
            title: _vm.$t("message.addressDetails.modal.title"),
            "ok-title": _vm.$t("message.addressDetails.modal.btn.ok"),
            "cancel-title": _vm.$t("message.addressDetails.modal.btn.cancel")
          },
          on: { ok: _vm.deleteAddress }
        },
        [
          _c("p", { staticClass: "mt-4" }, [
            _vm._v(_vm._s(_vm.$t("message.addressDetails.modal.question")))
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-56c3a64e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56c3a64e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/address/AddressDetails.vue
// module id = J2fc
// module chunks = 1